import { type FC } from 'react';

import cashPng from '/img/icons/cash.png';
import cashWebp from '/img/icons/cash.webp';

interface CashImageProps {
  size: number;
  className?: string;
}

const CashImage: FC<CashImageProps> = ({ size, className }) => {
  return (
    <picture
      style={{ width: size + 'px', height: size + 'px' }}
      className={className}
    >
      <source srcSet={cashWebp} type="image/webp" />
      <img src={cashPng} alt="cash" />
    </picture>
  );
};

export { CashImage };
